import { createReducer } from "@reduxjs/toolkit";
import { UIState, uiState } from "src/redux/ui/state";
import {
    toggleMenuOptions,
    showPaymentsInMenu,
    toggleChatDelayModal,
    toggleVeraWhatsappModal,
    toggleChatInMaintenanceModal,
    toggleOopsModal,
    toggleNotificationsConfigModal,
    toggleDownloadAppModal,
    Loading,
    uiLoading,
    toggleRequestsNotificationsStatus,
    RequestNotification,
} from "src/redux/ui/actions";
import { RequestNotificationsTypes } from "src/containers/requests/constants/requests-notifications";

class Reducers {
    static toggleMenuOptions(state: UIState): UIState {
        return {
            ...state,
            openMenuOption: !state.openMenuOption,
        };
    }

    static showPaymentsInMenu(state: UIState): UIState {
        return {
            ...state,
            showPaymentsInMenu: true,
        };
    }

    static toggleChatDelayModal(state: UIState): UIState {
        return {
            ...state,
            openChatDelayModal: !state.openChatDelayModal,
        };
    }

    static toggleVeraWhatsappModal(state: UIState): UIState {
        return {
            ...state,
            openVeraWhatsappModal: !state.openVeraWhatsappModal,
        };
    }

    static toggleChatInMaintenanceModal(state: UIState): UIState {
        return {
            ...state,
            openChatInMaintenanceModal: !state.openChatInMaintenanceModal,
        };
    }

    static toggleOopsModal(state: UIState): UIState {
        return {
            ...state,
            openOopsModal: !state.openOopsModal,
        };
    }

    static toggleNotificationsConfigModal(state: UIState): UIState {
        return {
            ...state,
            isNotificationsConfigModalOpen:
                !state.isNotificationsConfigModalOpen,
        };
    }

    static toggleRequestsNotificationsStatus(
        state: UIState,
        action: RequestNotification
    ): UIState {
        if (action.payload.requestType === RequestNotificationsTypes.CRM) {
            localStorage.setItem(
                RequestNotificationsTypes.CRM,
                !state.isCRMRequestsNotificationsEnabled + ""
            );
            return {
                ...state,
                isCRMRequestsNotificationsEnabled:
                    !state.isCRMRequestsNotificationsEnabled,
            };
        }
        return state;
    }

    static toggleDownloadAppModal(state: UIState): UIState {
        return {
            ...state,
            openDownloadAppModal: !state.openDownloadAppModal,
        };
    }

    static uiLoading(state: UIState, action: Loading): UIState {
        const { isLoading, afterDispatch } = action.payload;

        const newState = {
            ...state,
            loading: isLoading,
        };

        if (afterDispatch) {
            afterDispatch();
        }
        return newState;
    }
}

export const uiReducer = createReducer(uiState, {
    [toggleMenuOptions.type]: Reducers.toggleMenuOptions,
    [showPaymentsInMenu.type]: Reducers.showPaymentsInMenu,
    [toggleChatDelayModal.type]: Reducers.toggleChatDelayModal,
    [toggleVeraWhatsappModal.type]: Reducers.toggleVeraWhatsappModal,
    [toggleChatInMaintenanceModal.type]: Reducers.toggleChatInMaintenanceModal,
    [toggleOopsModal.type]: Reducers.toggleOopsModal,
    [toggleNotificationsConfigModal.type]:
        Reducers.toggleNotificationsConfigModal,
    [toggleRequestsNotificationsStatus.type]:
        Reducers.toggleRequestsNotificationsStatus,
    [toggleDownloadAppModal.type]: Reducers.toggleDownloadAppModal,
    [uiLoading.type]: Reducers.uiLoading,
});
